import React from 'react';
import { motion } from 'framer-motion';

const FloatingWa = () => {
  return (
    <div 
      className="fixed bottom-6 right-6 z-50 flex items-center gap-3"
      style={{ position: 'fixed', bottom: '24px', right: '24px', zIndex: 9999 }}
    >
      {/* Tooltip Label */}
      <motion.span 
        initial={{ opacity: 0, x: 10 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 1, duration: 0.5 }}
        className="hidden sm:inline-block rounded-full bg-white px-3.5 py-1.5 text-xs font-semibold text-lotus-ink shadow-md border border-lotus-petal/80 tracking-wide transition-all duration-300 hover:shadow-lg"
      >
        Need Help? Chat on WhatsApp
      </motion.span>

      {/* Floating Button */}
      <motion.a
        whileHover={{ scale: 1.12, rotate: 5 }}
        whileTap={{ scale: 0.9 }}
        target="_blank"
        rel="noopener noreferrer"
        href="https://api.whatsapp.com/send?phone=+919088771406&text=Hi%20Lotus%20Prana%2C%20I%20would%20like%20to%20know%20more%20about%20your%20services."
        aria-label="Chat on WhatsApp"
        className="relative flex items-center justify-center size-14 rounded-full bg-[#25D366] text-white shadow-xl hover:shadow-2xl transition-all duration-300 group focus:outline-none focus:ring-4 focus:ring-emerald-400/50"
        style={{ width: '56px', height: '56px', backgroundColor: '#25D366', borderRadius: '9999px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        {/* Subtle Pulse Animation */}
        <span className="absolute -inset-1 rounded-full bg-[#25D366]/40 animate-ping opacity-75 pointer-events-none" />

        <div className="relative z-10">
          <svg
            width="32px"
            height="32px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
              <path
                d="M6.014 8.00613C6.12827 7.1024 7.30277 5.87414 8.23488 6.01043L8.23339 6.00894C9.14051 6.18132 9.85859 7.74261 10.2635 8.44465C10.5504 8.95402 10.3641 9.4701 10.0965 9.68787C9.7355 9.97883 9.17099 10.3803 9.28943 10.7834C9.5 11.5 12 14 13.2296 14.7107C13.695 14.9797 14.0325 14.2702 14.3207 13.9067C14.5301 13.6271 15.0466 13.46 15.5548 13.736C16.3138 14.178 17.0288 14.6917 17.69 15.27C18.0202 15.546 18.0977 15.9539 17.8689 16.385C17.4659 17.1443 16.3003 18.1456 15.4542 17.9421C13.9764 17.5868 8 15.27 6.08033 8.55801C5.97237 8.24048 5.99955 8.12044 6.014 8.00613Z"
                fill="#ffffff"
              ></path>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 23C10.7764 23 10.0994 22.8687 9 22.5L6.89443 23.5528C5.56462 24.2177 4 23.2507 4 21.7639V19.5C1.84655 17.492 1 15.1767 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23ZM6 18.6303L5.36395 18.0372C3.69087 16.4772 3 14.7331 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C11.0143 21 10.552 20.911 9.63595 20.6038L8.84847 20.3397L6 21.7639V18.6303Z"
                fill="#ffffff"
              ></path>
            </g>
          </svg>
        </div>
      </motion.a>
    </div>
  );
};

export default FloatingWa;
